export const joinEventRooms = ({ socket, joinedRoomsRef, events }) => {
  if (!socket || !joinedRoomsRef || !Array.isArray(events)) return;
  events.forEach((event) => {
    const eventId = String(event?.event_uuid || event?.event_id || event?.id || '').trim();
    if (!eventId) return;
    const room = `event_${eventId}`;
    if (joinedRoomsRef.current.has(room)) return;
    try {
      socket.emit('join_event', eventId);
    } catch (_) {
      // no-op
    }
    joinedRoomsRef.current.add(room);
  });
};
